import lmsClient from '@/http/lms';

const ENDPOINT = '/livestreaming';
const ENDPOINT_FOLLOW = '/live-follow';

/**
 * Module Structure
 */
const state = {};

const getters = {};

const mutations = {};

const actions = {
  async getToken({}) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await lmsClient.get(`${ENDPOINT}/getToken`);

        if (response?.data?.status) {
          resolve(response.data);
        }

        reject(null);
      } catch (error) {
        console.log('## GPRIM ## error', error);
        reject(null);
      }
    });
  },
  async liveFollow({ rootGetters }, streamPayload) {
    const payload = {
      ...streamPayload,
      userID: rootGetters.dataUser?.userID,
    };

    return new Promise(async (resolve, reject) => {
      try {
        const response = await lmsClient.post(ENDPOINT_FOLLOW, payload);

        if (response?.data?.status) {
          resolve(response.data);
        }

        reject(null);
      } catch (error) {
        console.log('## GPRIM ## error', error);
        reject(null);
      }
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
